import { View, ViewModel } from "binder";
import { getAsBoolean } from "../../../utilities";
import { ColumnFilter } from "../columnFilter";
import  { DateFilterView } from "./dateFilter-view"

export class DateFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new DateFilterView();
    }
    public getTypeId(): string {
        return "VM-95E5DC43-155F-4B2A-A271-ED530DA5775D"
    }
    public set largerThan(v: moment.Moment) { this._largerThan = v; } public get largerThan(): moment.Moment { return this._largerThan;} private _largerThan: moment.Moment;
    public set smallerThan(v: moment.Moment) { this._smallerThan = v; } public get smallerThan(): moment.Moment { return this._smallerThan;} private _smallerThan: moment.Moment;
    public set applylarger(v: boolean) { this._applylarger =getAsBoolean(v); } public get applylarger(): boolean { return this._applylarger;} private _applylarger: boolean;
    public set applySmaller(v: boolean) { this._applySmaller =getAsBoolean(v); } public get applySmaller(): boolean { return this._applySmaller;} private _applySmaller: boolean;

}
